/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MediaBaseService } from '../media-base-service';
import { MediaApiConfiguration } from '../media-api-configuration';
import { MediaStrictHttpResponse } from '../media-strict-http-response';

import { KeyValueModel } from '../models/key-value-model';
import { publisherIdGet$Json } from '../fn/publisher/publisher-id-get-json';
import { PublisherIdGet$Json$Params } from '../fn/publisher/publisher-id-get-json';
import { publisherIdGet$Plain } from '../fn/publisher/publisher-id-get-plain';
import { PublisherIdGet$Plain$Params } from '../fn/publisher/publisher-id-get-plain';
import { publisherIdLanguagesGet$Json } from '../fn/publisher/publisher-id-languages-get-json';
import { PublisherIdLanguagesGet$Json$Params } from '../fn/publisher/publisher-id-languages-get-json';
import { publisherIdLanguagesGet$Plain } from '../fn/publisher/publisher-id-languages-get-plain';
import { PublisherIdLanguagesGet$Plain$Params } from '../fn/publisher/publisher-id-languages-get-plain';
import { PublisherListModel } from '../models/publisher-list-model';
import { PublisherModel } from '../models/publisher-model';
import { publisherPost$Json } from '../fn/publisher/publisher-post-json';
import { PublisherPost$Json$Params } from '../fn/publisher/publisher-post-json';
import { publisherPost$Plain } from '../fn/publisher/publisher-post-plain';
import { PublisherPost$Plain$Params } from '../fn/publisher/publisher-post-plain';
import { publisherPublisherListGet$Json } from '../fn/publisher/publisher-publisher-list-get-json';
import { PublisherPublisherListGet$Json$Params } from '../fn/publisher/publisher-publisher-list-get-json';
import { publisherPublisherListGet$Plain } from '../fn/publisher/publisher-publisher-list-get-plain';
import { PublisherPublisherListGet$Plain$Params } from '../fn/publisher/publisher-publisher-list-get-plain';
import { PublisherSearchItemModelSearchResultModel } from '../models/publisher-search-item-model-search-result-model';
import { publisherSearchPublisherPost$Json } from '../fn/publisher/publisher-search-publisher-post-json';
import { PublisherSearchPublisherPost$Json$Params } from '../fn/publisher/publisher-search-publisher-post-json';
import { publisherSearchPublisherPost$Plain } from '../fn/publisher/publisher-search-publisher-post-plain';
import { PublisherSearchPublisherPost$Plain$Params } from '../fn/publisher/publisher-search-publisher-post-plain';

@Injectable({ providedIn: 'root' })
export class MediaPublisherService extends MediaBaseService {
  constructor(config: MediaApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `publisherSearchPublisherPost()` */
  static readonly PublisherSearchPublisherPostPath = '/Publisher/SearchPublisher';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherSearchPublisherPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publisherSearchPublisherPost$Plain$Response(params?: PublisherSearchPublisherPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<PublisherSearchItemModelSearchResultModel>> {
    return publisherSearchPublisherPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherSearchPublisherPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publisherSearchPublisherPost$Plain(params?: PublisherSearchPublisherPost$Plain$Params, context?: HttpContext): Observable<PublisherSearchItemModelSearchResultModel> {
    return this.publisherSearchPublisherPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<PublisherSearchItemModelSearchResultModel>): PublisherSearchItemModelSearchResultModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherSearchPublisherPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publisherSearchPublisherPost$Json$Response(params?: PublisherSearchPublisherPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<PublisherSearchItemModelSearchResultModel>> {
    return publisherSearchPublisherPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherSearchPublisherPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publisherSearchPublisherPost$Json(params?: PublisherSearchPublisherPost$Json$Params, context?: HttpContext): Observable<PublisherSearchItemModelSearchResultModel> {
    return this.publisherSearchPublisherPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<PublisherSearchItemModelSearchResultModel>): PublisherSearchItemModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `publisherIdGet()` */
  static readonly PublisherIdGetPath = '/Publisher/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherIdGet$Plain$Response(params: PublisherIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<PublisherModel>> {
    return publisherIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherIdGet$Plain(params: PublisherIdGet$Plain$Params, context?: HttpContext): Observable<PublisherModel> {
    return this.publisherIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<PublisherModel>): PublisherModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherIdGet$Json$Response(params: PublisherIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<PublisherModel>> {
    return publisherIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherIdGet$Json(params: PublisherIdGet$Json$Params, context?: HttpContext): Observable<PublisherModel> {
    return this.publisherIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<PublisherModel>): PublisherModel => r.body)
    );
  }

  /** Path part for operation `publisherPublisherListGet()` */
  static readonly PublisherPublisherListGetPath = '/Publisher/PublisherList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherPublisherListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherPublisherListGet$Plain$Response(params?: PublisherPublisherListGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<PublisherListModel>>> {
    return publisherPublisherListGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherPublisherListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherPublisherListGet$Plain(params?: PublisherPublisherListGet$Plain$Params, context?: HttpContext): Observable<Array<PublisherListModel>> {
    return this.publisherPublisherListGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<PublisherListModel>>): Array<PublisherListModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherPublisherListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherPublisherListGet$Json$Response(params?: PublisherPublisherListGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<PublisherListModel>>> {
    return publisherPublisherListGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherPublisherListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherPublisherListGet$Json(params?: PublisherPublisherListGet$Json$Params, context?: HttpContext): Observable<Array<PublisherListModel>> {
    return this.publisherPublisherListGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<PublisherListModel>>): Array<PublisherListModel> => r.body)
    );
  }

  /** Path part for operation `publisherPost()` */
  static readonly PublisherPostPath = '/Publisher';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publisherPost$Plain$Response(params?: PublisherPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return publisherPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publisherPost$Plain(params?: PublisherPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.publisherPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publisherPost$Json$Response(params?: PublisherPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return publisherPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publisherPost$Json(params?: PublisherPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.publisherPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `publisherIdLanguagesGet()` */
  static readonly PublisherIdLanguagesGetPath = '/Publisher/{id}/Languages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherIdLanguagesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherIdLanguagesGet$Plain$Response(params: PublisherIdLanguagesGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return publisherIdLanguagesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherIdLanguagesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherIdLanguagesGet$Plain(params: PublisherIdLanguagesGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.publisherIdLanguagesGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publisherIdLanguagesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherIdLanguagesGet$Json$Response(params: PublisherIdLanguagesGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return publisherIdLanguagesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publisherIdLanguagesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publisherIdLanguagesGet$Json(params: PublisherIdLanguagesGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.publisherIdLanguagesGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

}
